export interface ApiErrorResponse {
  error: {
    code: number;
  };
}

const operationTextMap: Record<'create' | 'update' | 'delete', string> = {
  create: 'oprettelse',
  update: 'opdatering',
  delete: 'sletning',
};

export function getPricePolicyErrorMessage(
  pricePolicyName: string | null,
  err: ApiErrorResponse,
  operation: 'create' | 'update' | 'delete'
): string {
  switch (err.error.code) {
    // Duplicate name (v1 + v2 create/update)
    case 10521:
    case 10570:
    case 10581:
      return `Navnet: "${pricePolicyName}" findes allerede`;

    // Price value exceeded (v1 + v2 create/update)
    case 10522:
    case 10571:
    case 10582:
      return `Det indtastede beløb er for højt. Max pris er "99.9"`;

    // Invalid input (v2 create/update)
    case 10572:
    case 10583:
      return `Elpris bund skal være mindre end elpris loft`;

    // Fallback not found (v2 create/update)
    case 10573:
    case 10584:
      return `Den valgte fallback prispolitik blev ikke fundet`;

    // Fallback not fixed (v1 + v2 create/update)
    case 10574:
    case 10585:
      return `Fallback prispolitik skal være en fast prispolitik - ikke dynamisk`;

    // Fallback must not have organization (v2 create/update)
    case 10575:
    case 10586:
      return `En OK-level prispolitiks fallback må ikke tilhøre en organisation`;

    // Fallback organization different (v2 create/update)
    case 10576:
    case 10587:
      return `Fallback prispolitikkens organisation matcher ikke prispolitikkens organisation`;

    // Validation error (v2 create/update)
    case 10577:
    case 10588:
    case 10594:
      return `Der opstod en valideringsfejl`;

    // Update not found (v2)
    case 10580:
      return `Prispolitikken der skal opdateres blev ikke fundet`;

    // Delete not found (v2)
    case 10590:
      return `Prispolitikken der skal slettes blev ikke fundet`;

    // Delete - policy assigned to location (v2)
    case 10591:
      return `Kan ikke slettes — prispolitikken er tildelt en lokation`;

    // Delete - policy used as default (v2)
    case 10592:
      return `Kan ikke slettes — prispolitikken bruges som standard`;

    // Delete - policy used as fallback (v2)
    case 10593:
      return `Kan ikke slettes — prispolitikken bruges som fallback af en anden prispolitik`;

    default:
      return `Der opstod en ukendt fejl ved ${operationTextMap[operation]} af prispolitik`;
  }
}
